import { t } from '@web-solutions/module-localization';

import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function HealthSummaryCard({ idealWeight, goForWalks, healthConcerns, workOut }) {
  const workOutLevels = {
    'Low': t('onboarding.personalSummary.workOutLevels.none'),
    'Lightly active': t('onboarding.personalSummary.workOutLevels.light'),
    'Active': t('onboarding.personalSummary.workOutLevels.moderate'),
    'Very active': t('onboarding.personalSummary.workOutLevels.intense'),
  };

  const healthConcernsTranslations = {
    "I don't have any of These": t('onboarding.personalSummary.healthConcernsLevels.none'),
    'Hypertension': t('onboarding.personalSummary.healthConcernsLevels.hypertension'),
    'High Cholesterol': t('onboarding.personalSummary.healthConcernsLevels.highCholesterol'),
    'Obesity': t('onboarding.personalSummary.healthConcernsLevels.obesity'),
    'Diabetes': t('onboarding.personalSummary.healthConcernsLevels.diabetes'),
    'Heart Disease': t('onboarding.personalSummary.healthConcernsLevels.heartDisease'),
    'Cancer': t('onboarding.personalSummary.healthConcernsLevels.cancer'),
    'Lung Disease': t('onboarding.personalSummary.healthConcernsLevels.lungDisease'),
    'Thyroid Disease': t('onboarding.personalSummary.healthConcernsLevels.thyroidDisease'),
    'Stomach Disease': t('onboarding.personalSummary.healthConcernsLevels.stomachDisease'),
  };

  const summaryItems = [
    {
      icon: '🎯',
      title: t('onboarding.personalSummary.targetWeight'),
      value: `${idealWeight.value} ${t(`onboarding.personalSummary.${idealWeight.type}`)}`,
    },
    { icon: '🤸‍♂️', title: t('onboarding.personalSummary.activityLevel'), value: goForWalks },
    {
      icon: '💊',
      title: t('onboarding.personalSummary.healthConcernsTitle'),
      value: healthConcerns.includes("I don't have any of These")
        ? healthConcernsTranslations["I don't have any of These"]
        : healthConcerns
            .map((concern) => healthConcernsTranslations[concern] || concern)
            .join(', '),
    },
    { icon: '🏃‍♀️', title: t('onboarding.personalSummary.excercise'), value: workOutLevels[workOut] },
  ];

  return (
    <div className='health-summary-card'>
      {summaryItems.map(({ icon, title, value }, index) => (
        <div key={index} className='info-block'>
          <span>{icon}</span>
          <div className='info-content'>
            <Caption className='info-title'>{title}</Caption>
            <Text size='s' semibold className='info-value'>
              {value}
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
}

export default HealthSummaryCard;
